
(function(site,$){
	"use strict";
(function($){
	var location = ''
	var allOpen = false;
	var storedId;
    var beenPressed = false;
	var $window = $(window),
		$dom = {},
		trace = {push: function() {}},
		selectors = {
			wrap : '.privacy-main',
			contentContainer : '.privacy-content',
            subTitle : '.privacy-st-link',
            subDescription: '.privacy-desc'
		};
	function init() {
		// register modules/libraries for local use
		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};
		// cache DOM elements
		$dom.scroller = $(selectors.wrap);
		if(!$dom.scroller.length){
			return;
		}
	}
	// ON CLICK OF ACCORDION ITEM CONTAINER, IF THE ITEM IS ACTIVE
	//REMOVE THE ACTIVE CLASS, OTHERWISE ADD THE ACTIVE CLASS
	$(document).ready(function() {
		$(".set > a").on("click", function() {
		  if ($(this).hasClass("active")) {
			$(this).removeClass("active");
			$(this)
			  .siblings(".content")
			  .slideUp(200);
			$(".set > a i")
			  .removeClass("fa-minus")
			  .addClass("fa-plus");
		  } else {
			$(".set > a i")
			  .removeClass("fa-minus")
			  .addClass("fa-plus");
			$(this)
			  .find("i")
			  .removeClass("fa-plus")
			  .addClass("fa-minus");
			$(".set > a").removeClass("active");
			$(this).addClass("active");
			$(".content").slideUp(200);
			$(this)
			  .siblings(".content")
			  .slideDown(200);
		  }
		});
	  });

	  // IF THE ACCORDION ITEM CONTAINER HAS THE PRIVACY UNDERLINE
	  // REMOVE THE UNDERLINE STYLE.  OTHERWISE ADD IT
	  $(document).ready(function() {
		$(".set > a").on("click", function() {
		  if ($(this).parent().hasClass("privacy-underline")) {
			$(this).parent().removeClass("privacy-underline");
		  } else {
			$(".set").removeClass("privacy-underline");
			$(this).parent().addClass("privacy-underline");
		  }
		});
		$(".accordion-header.ui-accordion-header").on("click", function() {
			if($(this).hasClass('ui-accordion-header-active')){
				$(function(){
				//	$('header.site-header').css('display','none');
				});
			}else{
				$(function(){
					$('header.site-header').css('display','');
				});
			}
		});
	  });

// OPEN ALL ACCORDION ITEMS
    $(".open-all").click(function(){
        beenPressed = true;
        allOpen = !allOpen;
		allOpen == true ?
		$(".content").css({'display' : 'block'}) :
		$(".content").css({'display': 'none'});
    })
	//CONTROLS EXPAND ALL BUTTON, ADDS/ REMOVES ACTIVE CLASS
	// FOR ALL ACCORDION ITEMS, DEALS WITH UNDERLINE
	$(".open-all-container").click(function(){
		allOpen == true ?
		$(".open-all").html("<h3 style='margin-right: 5px'>Close All  </h3> &nbsp <i style='color: #89cff0' class='fa fa-minus'></i>") :
		$(".open-all").html("<h3 style='margin-right: 5px'>Expand All  </h3> &nbsp <i class='fa fa-plus'></i>");
		allOpen == true ?
		$(".accordion-title").addClass('active') :
		$(".accordion-title").removeClass('active');
		allOpen == true ? 
		$(".set").addClass('privacy-underline') :
		$(".set").removeClass('privacy-underline')
	})
	// STYLING FOR CONTENT SUB SUBSECTIONS FROM CONTENT CREATION PAGE
 	$('.privacy-policy-highlight-bar').prepend(
		"<div style='width: 6px; height: 30px; margin-right: 20px;' class='styling-element'></div>"
	)
	// THE PRINT FRIENDLY COMMAND TO GENEREATE PDF/ PRINT POPUP PAGE
	$(".print-pdf").click(function(){
		window.print()
	})

	//CHECK THE ADDRESS, AND FOR EACH OF THE SUBTITLES, IF THEY MATCH
	//OPEN THAT SUBTITLE AND ADD UNDERLINE
	$(document).ready(function(){
		if(window.location.hash.length > 0 && window.location.hash !== '#symphony') {
			$(window).on('load', function(){
				$('html, body').animate({
					scrollTop: $('.open-all').offset().top
				}, 'slow');
			})
			var hashContainer = window.location.hash.split('#')[1];
			var newContainer = hashContainer.replace(/%20/g, " ");
			var parsedHash = '';
			$(".accordion-title").each(function(){
				parsedHash = this.href.split('#')[1].replace(/%20/g, " ")
				if(parsedHash == newContainer){

					$(this).addClass('active')
					$(this).parent().addClass('privacy-underline')
					$(".set > a i")
					.removeClass("fa-minus")
					.addClass("fa-plus");
				  $(this)
					.find("i")
					.removeClass("fa-plus")
					.addClass("fa-minus");
				  $(".set > a").removeClass("active");
				  $(this).addClass("active");
				  $(this).parent().addClass('privacy-underline')
				  $(".content").slideUp(200);
				  $(this)
					.siblings(".content")
					.slideDown(200);
				}
			})
		}
		
		if (window.location.hash == '#symphony') {
			//slowScroll
			$('div.about').slideDown(function(){			
				//e.preventDefault();
				$('html, body').animate({
					scrollTop: ($('#symphony').first().offset().top - 50)
				},500);			
			});
		}
	})

	/**
	 * Scroll Content Left/Right 
	 * @param  {string} dir "left" or "right" direction to scroll
	 */

	$(function(){
		init();
	});
	})(jQuery);
})(window.site=window.site || {}, jQuery);